import { encode } from 'urlencode';
import { selectCurrentShare, selectShare } from './share.selector';
import { createSelector } from '@ngrx/store';

export const selectCurrentAttachments = createSelector(
  selectShare,
  selectCurrentShare,
  (share:any, currentShare: any) => {
    const {share: instance, result:{entities}} = share;
    if (!entities || !entities.attachments) {
      return [];
    }
    return Object.keys(entities.attachments)
      .map((key) => entities.attachments[key])
      .filter((attach) => attach.noteGlobalId == share.nodeId)
      .map(prepareURLs(currentShare))
      .map(prepareAttachmentSize);
  }
);

export const prepareAttachmentURLs = (currentShare, attachment) => {
  const attachmentURLEnding = '/' + attachment.globalId +
    '/' + encode(attachment.displayName);
  return Object.assign({}, attachment, {
    videoURL: currentShare.videoAttachmentBase + '/' + attachment.noteGlobalId + attachmentURLEnding,
    audioURL: currentShare.audioAttachmentBase + '/' + attachment.noteGlobalId + attachmentURLEnding,
    imageURL: currentShare.imageAttachmentBase + '/' + attachment.noteGlobalId + attachmentURLEnding,
    unknownURL: currentShare.unknownAttachmentBase + '/' + attachment.noteGlobalId + attachmentURLEnding,
    attachmentURL: currentShare.attachmentBase + attachmentURLEnding
  });
}

function prepareURLs(currentShare) {
  return (attachment) => {
    return prepareAttachmentURLs(currentShare, attachment)
  };
}

export function prepareAttachmentSize(attachment) {
  return Object.assign({}, attachment, {
    humanFileSize: humanReadableSize(attachment.size)
  });
}

function humanReadableSize(size) {
  let i = -1;
  const sizes = ['kB', 'MB', 'GB', 'TB'];
  do {
    size = size / 1024;
    i++;
  } while (size > 1024 && i < 4);
  return Math.max(0.1, size).toFixed(1) + ' ' + sizes[i];
}
